import React from 'react';
import { SectionHeader } from '../../../common';
import { P } from '../../../../components/Typography';
import { useTranslation } from 'react-i18next';
import { Ul, Li } from '../../../../components/List';
import A from '../../../../components/A';
import { Customer } from '../../../../types/customers';


const Contacts = ({ customer }: {customer: Customer}) => {
    const [t] = useTranslation();
    const { type, contact_for } = customer;
    if (type !== 'contact' && !contact_for) {
        return null;
    }
    return <div>
        <SectionHeader>
            {t('customers.customer.contacts.title')}
        </SectionHeader>
        {
            (!contact_for || contact_for.length === 0) ?
                <P>{t('customers.customer.contacts.no_contacts')}</P>
                :
                <Ul>
                    {contact_for.map(contact => (
                        <Li key={contact.customer_id}>
                            <A href={`../customers/${contact.customer_id}`}>
                                {contact.customer_id}
                            </A>
                        </Li>
                    ))}
                </Ul>}
    </div>;
};

export default Contacts;
